import type { LucideProps } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Iris's mark — the same gradient orb the home page hero uses (`.iris-orb` in
 * index.css).
 *
 * Takes `LucideProps` so it satisfies the same contract as every other icon on
 * these screens (`IconType` in settings-call/shared). It renders a tinted span
 * rather than an SVG, so only the props that mean something for a span are
 * read: the SVG-only ones (stroke, fill, …) are dropped deliberately instead of
 * being spread onto a DOM node that would reject them.
 */
export function IrisOrb({ className, size, 'aria-hidden': ariaHidden = true }: LucideProps) {
  return (
    <span
      className={cn('iris-orb inline-block shrink-0 rounded-full', className)}
      // Callers here size the orb with a className; `size` is honoured so a
      // lucide-style call site gets the dimensions it asked for either way.
      style={size === undefined ? undefined : { width: size, height: size }}
      aria-hidden={ariaHidden}
    />
  );
}
